import { Badge, BadgeSize, BadgeVariant } from "shared/components";

interface Props {
  isLast?: boolean;
  reverifyCount?: number;
  isArchived?: boolean;
  isFailed?: boolean;
}

const getDisplayConfigs = (isArchived?: boolean, isFailed?: boolean) => {
  if (isFailed) return { variant: BadgeVariant.ERROR, status: "Failed" };
  else if (isArchived)
    return { variant: BadgeVariant.BASE, status: "Completed" };
  else return { variant: BadgeVariant.SUCCESS, status: "Active" };
};

export const IncomeReverifyTab = ({
  isLast,
  reverifyCount,
  isArchived,
  isFailed
}: Props) => {
  const { variant, status } = getDisplayConfigs(isArchived, isFailed);

  return (
    <p className="text-sm">
      {isLast ? "Original verification " : `Re-verification ${reverifyCount} `}
      <Badge size={BadgeSize.SM} className="ml-1" variant={variant}>
        {status}
      </Badge>
    </p>
  );
};
